import React from "react";
import { Footer, Box, Paragraph } from "grommet";

const GrommetFooter = (props) => (
  <Footer colorIndex="grey-2" justify="center">
    <Box direction="row" align="center" pad={{ between: "medium" }}>
      <Paragraph margin="none">© 2020 Micosmo</Paragraph>
    </Box>
  </Footer>
);

export default GrommetFooter;



// WEBPACK FOOTER //
// ./src/components/footer.js